import './Service.css';

function Services(){
    return(
        <div className="our-service">
            <label className='our-text'>OUR SERVICES</label>
            <label className='practice-text'>Learn About Our Practice Areas</label>

            <label className='first-text'>Business operations</label><hr className='first-hr'></hr>
            <label className='second-text'>Marketing</label><hr className='second-hr'></hr>
            <label className='three-text'>Product Bootcamp</label><hr className='three-hr'></hr>

            <label className='first-text'id='company'>Company Trasformation</label><hr className='first-hr'id="first1"></hr>
            <label className='second-text'id="company">Value Matrix</label><hr className='second-hr'id="first1"></hr>
            <label className='three-text' id="company">Concept Design</label><hr className='three-hr'id="first1"></hr>

            <label className='first-text'id='ideas'>Ideas Sketching</label><hr className='first-hr'id="first2"></hr>
            <label className='second-text'id="ideas">Corporate Travel</label><hr className='second-hr'id="first2"></hr>
            <label className='three-text' id="ideas">Experience Maps</label><hr className='three-hr'id="first2"></hr>

            <label className='first-text'id='digital'>Digital Solution</label><hr className='first-hr'id="first3"></hr>
            <label className='second-text'id="digital">Consulting</label><hr className='second-hr'id="first3"></hr>
            <label className='three-text' id="digital">Technology Solution</label><hr className='three-hr'id="first3"></hr>

            <button className='learn-moke'><a href="https://en.wikipedia.org/wiki/Service"id="moke">LEARN MORE→</a></button>

        </div>
    )
}

export default Services;